window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    require('popper.js');
    require('bootstrap');
    require('select2');
    require('dropzone');
    require('cropperjs');
    require('jquery-cropper');
    require('jquery-countdown');
    window.moment = require('moment');
} catch (e) {
}

window.axios = require('axios');
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

window.Draggable = require('@shopify/draggable');

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    window.csrfToken = token.content;
} else {
    console.error('CSRF token not found');
}
